@if (title) {
  <div mat-dialog-title>
    <h2>{{ title | locale }}</h2>
  </div>
}

<mat-dialog-content>
  <p class="message">{{ localizeMessage ? (data.message | locale) : data.message }}</p>
  @if (errorMessage) {
    <p class="message">Error: {{ errorMessage }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (data.canCancel) {
    <button
      mat-flat-button
      class="low no-fill"
      color="primary"
      (click)="close()">
      {{ data.closeMessage ? (data.closeMessage | locale) : "close" | locale }}
    </button>
  }
  @for (action of actions; track action) {
    @if (action) {
      <button
        mat-flat-button
        class="height-sm"
        color="primary"
        (click)="close(action.function, true)">
        {{ action.message | locale }}
      </button>
    }
  }
</mat-dialog-actions>
